import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'

import DotsVertical from '@Icons/dots-vertical.svg?react'
import type { Product } from '@Store/types/product'
import { useDeleteProductDispatch } from '@Utils/context/modal/useDeleteProduct'
import { useEditProductDispatch } from '@Utils/context/modal/useEditProduct'

type ProductOptionsProps = {
  product: Product
}

export default function ProductOptions({
  product,
}: ProductOptionsProps): JSX.Element {
  const {
    setProduct: setProductForDelete,
    open: openDeleteModal,
    resetDeleteProduct,
  } = useDeleteProductDispatch()
  const {
    setProduct: setProductForEdit,
    open: openEditModal,
    resetEditProduct,
  } = useEditProductDispatch()

  const onEditProductClick = (): void => {
    setProductForEdit(product)
    resetEditProduct()
    openEditModal()
  }

  const onDeleteProductClick = (): void => {
    setProductForDelete(product)
    resetDeleteProduct()
    openDeleteModal()
  }

  return (
    <>
      <Menu as="div" className="relative text-left pt-3 md:pt-0">
        <Menu.Button className="mt-[6px] ml-1">
          <DotsVertical />
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute lg:right-0 mt-1 w-56 origin-top-right divide-y divide-gray-200 rounded-md bg-white-100 shadow-lg ">
            <div className="px-1 py-1 ">
              <Menu.Item>
                <button
                  className="text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm hover:bg-gray-50"
                  onClick={onEditProductClick}
                >
                  Edit Product
                </button>
              </Menu.Item>
              <Menu.Item>
                <button
                  className="text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm hover:bg-gray-50"
                  onClick={onDeleteProductClick}
                >
                  Delete Product
                </button>
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  )
}
